var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "256.000000pt",
    height: "256.000000pt",
    viewBox: "0 0 256.000000 256.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247 2549 c-91 -22 -178 -95 -219 -184 l-23 -50 -3 -848 -3 -848 30 -29 c32 -32 54 -36 87 -17 11 7 121 95 243 197 l221 185 628 5 627 5 56 28 c66 32 132 99 162 165 22 46 22 54 22 602 0 549 0 555 -22 602 -30 66 -104 141 -166 169 l-52 24 -775 2 c-433 1 -792 -3 -813 -8z m1594 -172 c18 -12 44 -38 56 -56 l23 -34 0 -527 0 -527 -23 -34 c-12 -18 -38 -44 -56 -56 l-34 -23 -629 0 c-461 0 -635 -3 -651 -12 -19 -10 -276 -220 -344 -281 l-23 -20 0 740 0 740 23 34 c12 18 38 44 56 56 l34 23 767 0 767 0 34 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509 2051 c-16 -16 -29 -39 -29 -51 0 -12 13 -35 29 -51 l29 -29 502 0 502 0 29 29 c37 37 37 65 0 102 l-29 29 -502 0 -502 0 -29 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509 1731 c-16 -16 -29 -39 -29 -51 0 -12 13 -35 29 -51 l29 -29 342 0 342 0 29 29 c16 16 29 39 29 51 0 12 -13 35 -29 51 l-29 29 -342 0 -342 0 -29 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2190 1892 c-38 -38 -38 -65 -1 -103 21 -21 39 -29 64 -29 41 0 93 -33 124 -79 l23 -34 0 -699 c0 -557 -3 -698 -12 -692 -7 4 -67 51 -133 104 -66 53 -130 102 -142 108 -16 9 -181 12 -611 12 l-589 0 -34 23 c-60 40 -79 80 -79 164 0 69 -2 77 -29 104 -38 37 -65 37 -103 -2 -31 -30 -31 -31 -26 -117 4 -59 12 -104 28 -139 26 -62 100 -135 168 -166 46 -22 55 -22 632 -25 l586 -3 193 -155 c107 -85 204 -157 217 -160 27 -7 59 9 79 40 14 21 15 120 13 827 -3 802 -3 804 -25 851 -48 105 -147 179 -260 194 -49 6 -54 5 -83 -24z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.a4f4aa2de5c5e89918cd3b5f40cd5875.svg";
export { ForwardRef as ReactComponent };